module.exports = __webpack_public_path__ + "static/media/2.58b6e20b.jpg";